'use strict';

// require libs for server codes

const moment = require('moment');
moment.updateLocale('ja', require('moment/locale/ja'));

function empty(s) {
  return s || '-';
}

function formatYearMonth(date) {
  return date ? moment(date).format('YYYY-MM') : '';
}

function formatDate(date) {
  return date ? moment(date).format('YYYY-MM-DD') : '';
}

function formatFullDate(date) {
  return date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : '';
}

function formatInt(i) {
  if (i === undefined || i === null || isNaN(i)) {
    return '';
  }
  let value = i < 0 ? '-' : '';
  value += Math.abs(i).toFixed(0);
  return value;
}

function formatFloat(f, digits) {
  if (f === undefined || f === null || isNaN(f)) {
    return '';
  }
  digits = digits || 2;
  let value = f < 0 ? '-' : '';
  value += Math.abs(f).toFixed(digits);
  return value;
}

function formatIntWithCommas(i) {
  return numberWithCommas(formatInt(i));
}

function formatFloatWithCommas(f, digits) {
  return numberWithCommas(formatFloat(f, digits));
}

function numberWithCommas(x) {
  let index = x.indexOf('.');
  if (index >= 0) {
    return x.substring(0, index).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + x.substring(index);
  } else {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}

function formatNumber(size) {
  if (!size && size !== 0) {
    return '';
  } else if (size > 1024 * 1024) {
    return formatFloat(size / 1024 / 1024) + 'M';
  } else if (size > 1024) {
    return formatFloat(size / 1024) + 'K';
  } else {
    return formatInt(size);
  }
}

function formatSize(size) {
  if (!size && size !== 0) {
    return '';
  } else if (size > 1024 * 1024) {
    return formatFloat(size / 1024 / 1024) + 'GB';
  } else if (size > 1024) {
    return formatFloat(size / 1024) + 'MB';
  } else {
    return formatFloat(size) + 'KB';
  }
}

function formatSizeGB(size) {
  if (!size && size !== 0) {
    return '';
  }
  return formatInt(size / 1024 / 1024) + 'GB';
}

function formatPercentage(num) {
  return Math.round(num * 100) + '%';
}

function htmlEncode(str) {
  let buf = [];
  for (let i = str.length - 1; i >= 0; i--) {
    buf.unshift(['&#', str[i].charCodeAt(), ';'].join(''));
  }
  return buf.join('');
}

function formatSimpleHtml(text) {
  if (!text) {
    return '';
  }
  let sections = text.split('\n');
  let regex = /http(s?):\/\/[\S]+/ig;
  sections = sections.map(section => {
    regex.lastIndex = 0;
    let result = '', index = 0, match;
    while ((match = regex.exec(section)) != null) {
      result += htmlEncode(section.substring(index, match.index));
      let url = match[0];
      index = match.index + url.length;
      let encodedUrl = htmlEncode(url);
      result += `<a href="${encodedUrl}" target="_blank">${encodedUrl}</a>`;
    }
    result += htmlEncode(section.substring(index));
    return result;
  });
  return sections.join('<br/>');
}

function formatBoolean(value) {
  return value ? '是' : '否';
}

function getDate(date) {
  let dateString = moment(date).format('YYYY-MM-DD');
  return moment(dateString + ' 00:00 +0000', 'YYYY-MM-DD HH:mm ZZ').toDate();
}

function getLocalDate(date) {
  let dateString = moment(date).format('YYYY-MM-DD');
  return moment(dateString + ' 00:00', 'YYYY-MM-DD HH:mm').toDate();
}

let formatter = {};

formatter.empty = empty;
formatter.formatYearMonth = formatYearMonth;
formatter.formatDate = formatDate;
formatter.formatFullDate = formatFullDate;
formatter.formatInt = formatInt;
formatter.formatFloat = formatFloat;
formatter.formatIntWithCommas = formatIntWithCommas;
formatter.formatFloatWithCommas = formatFloatWithCommas;

[1, 2, 3, 4, 5, 6, 7, 8, 9].forEach(i => {
  formatter['formatFloat' + i] = function (f) {
    return formatFloat(f, i);
  };
  formatter['formatFloat' + i + 'WithCommas'] = function (f) {
    return formatFloat(f, i);
  };
});

formatter.formatNumber = formatNumber;
formatter.formatSize = formatSize;
formatter.formatSizeGB = formatSizeGB;
formatter.formatPercentage = formatPercentage;
formatter.formatSimpleHtml = formatSimpleHtml;
formatter.formatBoolean = formatBoolean;
formatter.getDate = getDate;
formatter.getLocalDate = getLocalDate;

module.exports = formatter;


// WEBPACK FOOTER //
// ./helpers/data-formatter.js